import { CaseManCallLog } from "../model/caseMan/CaseManCallLog";

export class CaseManCallAddCommand{
    caseId:string;
    callLogView:CaseManCallLog;
    constructor(caseId:string, callLogView:CaseManCallLog){
        this.caseId = caseId;
        this.callLogView = callLogView;
    }
}